import { useState, useEffect } from 'react';
import Navigation from '../../components/base/Navigation';
import Footer from '../../components/base/Footer';

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  useEffect(() => {
    document.title = 'Project Gallery - Evolution Home | 350+ Completed Projects';
  }, []);

  const galleryImages = [
    { id: 1, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/9c5f98a5fb68ed0a1e5362d71d3a8c2f.png' },
    { id: 2, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/0f2f636dac1fd00b0adb84975aeec67b.png' },
    { id: 3, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/a50993d33ad3f170d9de88d6ae2be6ea.png' },
    { id: 4, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/79815cee31549ab3a89fdc8033eb5b96.png' },
    { id: 5, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/343c99e6802b11bd6c648f82124bb829.png' },
    { id: 6, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/079e92adf83c72e22acb84b9ea67ee00.png' },
    { id: 7, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/f7f0e5cceac8b2b6b64ec0f11a7d4bce.png' },
    { id: 8, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/ff3119a7af9f145da745d1ebf444d8b4.png' },
    { id: 9, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/3603578ec25ec56a15a24e3498eaa115.jfif' },
    { id: 10, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/b59adb1f9d747d036c1d55b6faa095b9.jfif' },
    { id: 11, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/832038222f3705db6f067fd1370a78b2.png' },
    { id: 12, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/a06c67446f523251bfb0253ff414c39d.png' },
    { id: 13, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/db7624d387c58e3bb707a59b98702c04.png' },
    { id: 14, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/ed310a31d3fe5ba412215c2999cf983f.png' },
    { id: 15, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/0c85ab2a4e4a07fc6960bfd472654d1d.png' },
    { id: 16, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/35f65444f7f5a3ba929a5ac743cba856.png' },
    { id: 17, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/c4ff5471e04a95513aaea355b85a2861.png' },
    { id: 18, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/df772333963fdeda4600955134e0f0b0.png' },
    { id: 19, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/e349fc72a55c8597d89b4ba5f41536bc.png' },
    { id: 20, image: 'https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/eb08194e4c3585fdf4b8dd1fd9767f99.png' },
  ];

  const testimonials = [
    {
      name: 'Sarah Johnson',
      location: 'Toronto',
      text: 'Evolution Home transformed our kitchen beyond our wildest dreams. The attention to detail and quality of work is exceptional.',
      rating: 5,
      project: 'Kitchen Renovation'
    },
    {
      name: 'Michael Chen',
      location: 'Mississauga',
      text: 'Professional, reliable, and incredibly skilled. Our bathroom renovation was completed on time and exceeded expectations.',
      rating: 5,
      project: 'Bathroom Remodel'
    },
    {
      name: 'David Rodriguez',
      location: 'Brampton',
      text: 'The flooring installation was flawless. The team was courteous and left our home spotless every day.',
      rating: 5,
      project: 'Hardwood Flooring'
    },
    {
      name: 'Nishant Patel',
      location: 'Vaughan',
      text: 'Our hasty mart store renovation not only looks amazing but has also improved productivity and client impressions significantly.',
      rating: 5,
      project: 'Commercial Renovation'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Section */}
      <section 
        className="relative h-96 flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/3457d1c84b9c94d923cf17353f8689e8.jpg')`
        }}
      >
        <div className="text-center text-white px-4">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">Our Gallery</h1>
          <p className="text-xl text-gray-200">Showcasing 350+ completed luxury renovation projects</p>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-black mb-4">Project Gallery</h2>
            <p className="text-xl text-gray-600">A collection of our finest renovation work. Like a specific project? Click to expand.</p>
          </div>

          {/* Masonry Gallery */}
          <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
            {galleryImages.map((item, index) => (
              <div 
                key={item.id}
                className="break-inside-avoid bg-white rounded-lg shadow-lg overflow-hidden group hover:shadow-xl transition-all duration-300 cursor-pointer"
                onClick={() => setSelectedImage(item.image)}
              >
                <div className="relative overflow-hidden">
                  <img 
                    src={item.image}
                    alt={`Gallery Image ${item.id}`}
                    className="w-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                    <div className="w-8 h-8 bg-amber-600 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
                      <i className="ri-zoom-in-line text-white"></i>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Carousel */}
      <section className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">What Our Clients Say</h2>
            <p className="text-xl text-gray-300">Real feedback from real renovations</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white/5 backdrop-blur-sm rounded-lg p-6 border border-red-600/20 hover:border-red-600/50 transition-all duration-300">
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <div key={i} className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-star-fill text-red-600"></i>
                    </div>
                  ))}
                </div>
                <p className="text-gray-300 mb-4 italic">"{testimonial.text}"</p>
                <div>
                  <div className="font-semibold text-white">{testimonial.name}</div>
                  <div className="text-red-600 text-sm">{testimonial.project}</div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 cursor-pointer"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-4xl max-h-full">
            <img 
              src={selectedImage}
              alt="Gallery Image"
              className="max-w-full max-h-full object-contain"
            />
            <button 
              className="absolute top-4 right-4 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-all duration-300 cursor-pointer"
              onClick={() => setSelectedImage(null)}
            >
              <i className="ri-close-line text-xl"></i>
            </button>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
